import {Box, Switch, FormControlLabel } from '@mui/material';
import { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import { useNavigate } from "react-router-dom";
import EditIcon from "assets/EditIcon.svg";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#0A3575",
    color: theme.palette.common.white,
    height: "52px",
    fontSize: "16px",
    fontWeight: 600,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: "16px",
    height: "100px",
    color: "#191E31",
    fontWeight: 600,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "#ffffff",
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const RuleTable = ({ columns, rows ,url, toggle}) => {
  const navigate = useNavigate();
  const [checked, setChecked] = useState(false);
  const [rowss, setRowss] = useState(rows);


  useEffect(() => {
   
  }, [rowss]);

  const handleChange = (event, row) => {
    toggle(event.target.checked, row)
    //setChecked(event.target.checked);
   // const isChecked = event.target.checked;

    // Update the specific row's isActive value
    // setRowss((prevRows) =>
    //   prevRows.map((row, index) =>
    //     index === rowIndex ? { ...row, isActive: isChecked } : row
    //   )
    // );
  };
  const CustomSwitch = styled(Switch)({
    '&.MuiSwitch-root': {
      borderRadius: '100px', // Customize root border radius
      width: '40px', // Custom switch width
      height: '20px', // Custom switch height
      padding: '0px', // Adjust padding around the switch
    },
    '& .MuiSwitch-switchBase': {
      padding: '0px', // Customize the switch base padding
      borderRadius:"100px",
      top:'1px',
      left:'1px'
    },
    '& .MuiSwitch-thumb': {
      width: 18, // Customize the thumb size
      height: 18,
      backgroundColor: checked ? '#ffffff' : '#ffffff', // Custom color when switched on
    },
    '& .MuiSwitch-track': {
      borderRadius: 20,
      backgroundColor: checked ? '#007BFF' : '#ccc', // Track color customization
      opacity: 1, // Control opacity
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
      backgroundColor: '#007BFF', // Custom color when checked
      opacity: 1, // Set full opacity when checked
    },
  });
  return (
    <Box>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 700 }} aria-label="customized table">
          <TableHead>
            <TableRow className='table-header-radius'>
              {columns?.map((column, index) => (
                <StyledTableCell key={index} align={column.align || "left"}>
                  {column.label}
                </StyledTableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows?.map((row, rowIndex) => (
              <StyledTableRow key={rowIndex}>
                {columns?.map((column, colIndex) => (
                  <StyledTableCell
                    key={colIndex}
                    align={column.align || "left"}
                  >
                    {column.field === "action" ? (
                      // <img
                      //   style={{ cursor: "pointer" }}
                      //   onClick={() =>
                      //     navigate(`${url}`, { state: { rowData: row } })
                      //   }            
                      //   src={EditIcon}
                      //   alt="Edit"
                      // />
                      <FormControlLabel
                      control={
                        <CustomSwitch
                        key={rowIndex}
                          checked={row.isActive}
                          onChange={(event) => handleChange(event, row)} 
                          color="primary"
                        />
                      }
                    //   label={row.isActive}
                      
                    />
                    ) : (
                      row[column.field]
                    )}
                  </StyledTableCell>
                ))}
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default RuleTable;
